import tw from 'tailwind-styled-components'

const ActionStatusContainer = tw.div`
text-center
text-white
font-bold
text-[15px]
transition-all
`

const Content = tw.div`
h-[39px]
rounded-[4px]
flex
justify-center
items-center
gap-2
pointer-events-none
mb-3
`

export { ActionStatusContainer, Content }
